/* import __COLOCATED_TEMPLATE__ from './customer-settings.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import templateOnlyComponent from '@ember/component/template-only';

interface Args {
  handler: any; // Handler from descriptor-details-handler component
  item: any; // Item yielded from form.Item
}

interface Signature {
  Args: Args;
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

const CustomerSettings = templateOnlyComponent<Signature>();
export default CustomerSettings;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Settings::ConversationAttributes::DescriptorDetailsBody::CustomerSettings': typeof CustomerSettings;
    'settings/conversation-attributes/descriptor-details-body/customer-settings': typeof CustomerSettings;
  }
}
